module.exports = "/_next/static/resources/array-a3b198dd472db8260a09d80ed36546eb.jpg";